import LevelSelector from './src/main.js'

export default LevelSelector



// WEBPACK FOOTER //
// ./index.js